<template>
  <div>
    <PageHeader :title="isEdit ? 'Edit Contract Template' : 'New Contract Template'" showBack />
    <div class="card p-4">
      <b-form @submit.prevent="saveTemplate">
        <b-form-group label="Template Name" label-class="form-label">
          <b-form-input v-model="form.name" placeholder="Enter template name" required />
        </b-form-group>

        <b-form-group label="Template Type" label-class="form-label">
          <b-form-radio-group v-model="form.is_pdf_template" :options="[{ value: true, text: 'PDF Template' }, { value: false, text: 'HTML Template' }]" />
        </b-form-group>

        <template v-if="!form.is_pdf_template">
          <b-form-group label="Variables" label-class="form-label">
            <b-button v-for="v in variables" :key="v" size="sm" variant="outline-secondary" class="mr-1 mb-1" @click="insertVariable(v)">{{ v }}</b-button>
            <b-button size="sm" variant="outline-info" class="mr-1 mb-1" @click="insertVariable(signatureVar)">{{ signatureVar }}</b-button>
          </b-form-group>
          <b-form-group label="Content (HTML)" label-class="form-label">
            <editor v-if="showEditor" v-model="form.content_html" :api-key="tinymceKey" :init="editorConfig" />
          </b-form-group>
        </template>

        <template v-else>
          <b-alert show variant="info" class="mb-3">
            <strong>PDF Template</strong> — Save the template first, then use the <strong>Open PDF Builder</strong> button below to upload a PDF and place signature fields.
          </b-alert>
        </template>

        <div class="d-flex align-items-center mt-3">
          <b-button type="submit" variant="primary" :disabled="isSaving">{{ isSaving ? 'Saving...' : 'Save Template' }}</b-button>
          <b-button v-if="isEdit && form.is_pdf_template" variant="outline-primary" class="ml-2" @click="openBuilder">Open PDF Builder</b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { TEMPLATE_VARIABLES } from '../../common/constants';
import PageHeader from '../../components/Ui/PageHeader.vue';
import Editor from '@tinymce/tinymce-vue';

const SIGN_URL = process.env.VUE_APP_SIGN_URL || 'http://localhost:8084';

export default {
  name: 'ContractTemplateEditor',
  components: { PageHeader, Editor },
  data() {
    return {
      form: { name: '', content_html: '', variables: [], is_pdf_template: true }, isEdit: false, isSaving: false, showEditor: true,
      signatureVar: '{{SIGNATURE}}',
      tinymceKey: process.env.VUE_APP_TINYMCE_API_KEY, variables: TEMPLATE_VARIABLES,
      editorConfig: { height: 500, menubar: true, plugins: 'lists link image table code fullscreen', toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist | link image | code fullscreen' },
    };
  },
  computed: {
    ...mapGetters('auth', ['getAuthToken']),
  },
  methods: {
    ...mapActions('contractTemplate', ['getContractTemplate', 'createContractTemplate', 'updateContractTemplate']),
    insertVariable(v) { this.form.content_html += v; },
    openBuilder() {
      const id = this.$route.params.id;
      window.open(`${SIGN_URL}/template-builder/${id}?token=${this.getAuthToken}`, '_blank');
    },
    async loadTemplate() {
      const id = this.$route.params.id;
      if (!id) return;
      this.isEdit = true;
      try { const res = await this.getContractTemplate(id); this.form = res.data; } catch (err) { this.makeToast('danger', 'Failed to load'); }
    },
    async saveTemplate() {
      this.isSaving = true;
      try {
        const user = this.$store.getters['auth/getLoggedInUser'];
        this.form.school = user.school.id;
        if (this.isEdit) { await this.updateContractTemplate({ id: this.$route.params.id, data: this.form }); this.makeToast('success', 'Updated'); }
        else { await this.createContractTemplate(this.form); this.makeToast('success', 'Created'); this.$router.push({ name: 'contract-templates-list' }); }
      } catch (err) { this.makeToast('danger', 'Save failed'); }
      finally { this.isSaving = false; }
    },
  },
  created() { this.loadTemplate(); },
};
</script>
